var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('app-sidebar'),_c('div',{staticClass:"app-content"},[_c('app-header'),_c('main',{staticClass:"app-main"},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }